// extracted by mini-css-extract-plugin
module.exports = {"gallery":"galeryDesktopCarousel_gallery__65wuX","containerImages":"galeryDesktopCarousel_containerImages__TMvOO"};